/* =====================================================================
   NFL MUNICH GAME 2026 — Module de réservation (thème Shopify)
   Catégories (produits) → bloc (variante « Bloc ») → billets (−/+) → panier.
   - Données : <script id="mg-catalog"> rendu par Liquid (prix, couleurs,
     variantes et stock réels). Le plan lit le stock des variantes.
   - Une catégorie est toujours prête à acheter : meilleur bloc présélectionné.
   - n billets max. par commande = plafond interne / prix (jamais en euros).
   - Fiche produit : changer de catégorie ouvre la fiche correspondante.
   ===================================================================== */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const MAP_CODES = ['PRIME', 'CAT1', 'CAT2', 'CAT3', 'CAT4', 'CAT5', 'CAT6'];
  const FALLBACK_COLORS = { PRIME: '#C9A227', CAT1: '#0076B6', CAT2: '#4F5BD5', CAT3: '#0E9F8E', CAT4: '#E07A1F', CAT5: '#C2185B', CAT6: '#6B7A8C' };

  function readCatalog() {
    const el = document.getElementById('mg-catalog');
    if (!el) return [];
    let raw = [];
    try { raw = JSON.parse(el.textContent); } catch (e) { return []; }
    return raw.filter((c) => MAP_CODES.indexOf(c.code) > -1).sort((a, z) => (a.rank || 0) - (z.rank || 0)).map((c) => Object.assign({}, c, {
      label: c.code === 'PRIME' ? 'Prime' : MG.t('cat_short', { n: c.code.replace('CAT', '') }),
      color: /^#[0-9a-f]{6}$/i.test(c.color || '') ? c.color : FALLBACK_COLORS[c.code],
    }));
  }

  function mount(root, catalog) {
    const S = window.MGStadium;
    const T = window.MG_T || {};
    const cats = Object.fromEntries(catalog.map((c) => [c.code, c]));
    // Stock réel des variantes → plan
    const stock = {};
    catalog.forEach((c) => Object.keys(c.variants || {}).forEach((b) => { stock[b] = c.variants[b].qty; }));
    S.setStock(stock);
    const blocks = S.computeBlocks();
    const byCat = {};
    catalog.forEach((c) => {
      const bs = blocks.filter((b) => b.cat === c.code && c.variants && c.variants[b.block]);
      byCat[c.code] = { blocks: bs, out: bs.every((b) => !b.remaining), ratio: S.availability(bs) };
    });
    const pageCat = root.hasAttribute('data-product-page') ? root.dataset.cat : null; // fiche produit
    const state = { cat: null, block: null, qty: 2, auto: false };
    const side = (s) => (T.sides && T.sides[s]) || s;
    const name = (c) => (c.code === 'PRIME' ? c.name : c.label + ' · ' + c.name);
    const variantOf = (b) => (cats[b.cat] && cats[b.cat].variants[b.block]) || null;
    // Ligne de panier : plafond + limite produit (mg26.max_per_order), couleur de la catégorie
    const itemOf = (c, v) => ({ id: v ? v.id : 0, price: c.price, type: c.type || 'Ticket', max: c.max || 0, color: c.color });

    root.classList.add('selector');
    root.innerHTML =
      '<div class="selector__cats" role="radiogroup" aria-label="' + MG.t('tickets') + '" data-cats></div>' +
      '<div class="selector__body">' +
        '<div class="selector__map">' +
          '<div class="selector__stage">' +
            '<span class="selector__side selector__side--top">' + MG.t('side_top') + '</span>' +
            '<span class="selector__side selector__side--bottom">' + MG.t('side_bottom') + '</span>' +
            '<div data-stadium></div>' +
          '</div>' +
          '<ul class="selector__legend" role="list"><li><span class="lg lg--sel"></span>' + MG.t('legend_sel') + '</li><li><span class="lg lg--av"></span>' + MG.t('legend_av') + '</li><li><span class="lg lg--out"></span>' + MG.t('legend_out') + '</li></ul>' +
        '</div>' +
        '<div class="selector__panel">' +
          '<div class="atc" data-atc>' +
            '<div class="atc__head"><span class="atc__swatch"></span><div><strong data-s="name"></strong><small data-s="tier"></small></div><span class="atc__unit"><b data-s="price"></b><small>' + MG.t('per_ticket') + '</small></span></div>' +
            '<fieldset class="atc__group"><legend>' + MG.t('block') + ' <span data-s="blocks-note"></span></legend><div class="chips" role="radiogroup" data-chips></div></fieldset>' +
            '<div class="atc__qtyrow">' +
              '<div><span class="atc__k" id="atc-qty-' + uid + '">' + MG.t('tickets') + '</span><small data-s="limit"></small></div>' +
              '<div class="qty qty--lg" role="group" aria-labelledby="atc-qty-' + uid + '">' +
                '<button type="button" data-step="-1" aria-label="' + MG.t('remove_one') + '"><svg><use href="#i-minus"/></svg></button>' +
                '<output data-s="qty" aria-live="polite">2</output>' +
                '<button type="button" data-step="1" aria-label="' + MG.t('add_one') + '"><svg><use href="#i-plus"/></svg></button>' +
              '</div>' +
            '</div>' +
            '<label class="together" data-s="together" hidden><input type="checkbox" checked data-together><span class="together__box" aria-hidden="true"><svg><use href="#i-check"/></svg></span><span class="together__txt"><strong>' + MG.t('together') + '</strong><small data-s="together-text"></small></span></label>' +
            '<div class="total-board"><div class="total-board__l"><span class="total-board__k">' + MG.t('total') + '</span><small data-s="recap"></small></div><strong class="total-board__v" data-s="total"></strong></div>' +
            '<button class="btn btn--primary btn--lg btn--block btn--cta atc__btn" type="button" data-s="add"><span class="btn__label">' + MG.t('add') + '</span><span class="btn__chip" aria-hidden="true"><svg><use href="#i-cart"/></svg></span></button>' +
            '<p class="atc__trust"><svg class="icon" aria-hidden="true"><use href="#i-shield"/></svg>' + MG.t('trust') + '</p>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="atc-bar" data-bar aria-hidden="true">' +
        '<div class="atc-bar__txt"><small data-s="bar-recap"></small><strong data-s="bar-total"></strong></div>' +
        '<button class="btn btn--primary" type="button" data-s="bar-add" tabindex="-1">' + MG.t('add') + '</button>' +
      '</div>';

    const map = S.render($('[data-stadium]', root), {
      mode: 'full', theme: 'light', categories: cats,
      t: { block: T.block, sold_out: T.sold_out, only_left: T.only_left, seats_available: T.seats_available, side_of: T.side_of, from: T.from },
      sideName: side, money: MG.money, ariaLabel: MG.t('side_top') + ' / ' + MG.t('side_bottom'),
    });
    const s = (k) => $('[data-s="' + k + '"]', root);

    /* --- Tuiles catégories --- */
    $('[data-cats]', root).innerHTML = catalog.map((c) => {
      const out = byCat[c.code].out;
      const low = !out && byCat[c.code].ratio < 0.12;
      return '<button type="button" class="cat-tile' + (out ? ' is-out' : '') + '" role="radio" aria-checked="false"' + (out ? ' aria-disabled="true"' : '') + ' data-cat="' + c.code + '" style="--cat:' + c.color + '">' +
        '<span class="cat-tile__label">' + (c.code === 'PRIME' ? MG.t('premium') : c.label) + '</span>' +
        '<span class="cat-tile__name">' + c.name + '</span>' +
        '<span class="cat-tile__foot"><span class="cat-tile__price">' + MG.money(c.price) + '</span>' +
          (out ? '<span class="cat-tile__flag is-out">' + MG.t('sold_out') + '</span>' : low ? '<span class="cat-tile__flag is-low">' + MG.t('last_seats') + '</span>' : '') + '</span>' +
      '</button>';
    }).join('');

    // Mobile : les catégories forment un rail horizontal ; la tuile choisie est ramenée en vue
    const rail = $('[data-cats]', root);
    const railEnd = () => rail.classList.toggle('is-end', rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4);
    rail.addEventListener('scroll', railEnd, { passive: true });
    let railReady = false;
    function revealTile(code) {
      const tile = $('.cat-tile[data-cat="' + code + '"]', rail);
      if (tile && rail.scrollWidth > rail.clientWidth) {
        const left = rail.scrollLeft + tile.getBoundingClientRect().left - rail.getBoundingClientRect().left - 16;
        rail.scrollTo({ left: Math.max(0, left), behavior: railReady ? 'smooth' : 'auto' });
      }
      railReady = true;
      railEnd();
    }

    const best = (code) => byCat[code].blocks.filter((b) => b.remaining).sort((a, z) => z.view - a.view || z.remaining - a.remaining)[0] || null;

    function goTo(code, block) {
      const c = cats[code];
      if (!c || !c.url) return false;
      window.location.href = c.url + (block ? '?bloc=' + encodeURIComponent(block) : '');
      return true;
    }

    function setCat(code, block) {
      if (!cats[code] || byCat[code].out) return;
      state.cat = code;
      const c = cats[code];
      root.style.setProperty('--sel', c.color);
      $$('.cat-tile', root).forEach((t) => t.setAttribute('aria-checked', String(t.dataset.cat === code)));
      revealTile(code);
      map.highlight(code);
      s('name').textContent = name(c);
      s('tier').textContent = [c.tier, c.zone].filter(Boolean).join(' · ');
      s('price').textContent = MG.money(c.price);
      s('limit').textContent = MG.t('limit', { n: MG.cart.perOrder(itemOf(c)) });
      const list = byCat[code].blocks.slice().sort((a, z) => a.block - z.block);
      s('blocks-note').textContent = MG.t('blocks_note', { n: list.filter((b) => b.remaining).length, m: list.length });
      $('[data-chips]', root).innerHTML = list.map((b) =>
        '<button type="button" class="chip-b' + (b.remaining && b.remaining < 40 ? ' is-low' : '') + '" role="radio" aria-checked="false" data-block="' + b.block + '"' + (b.remaining ? '' : ' disabled') + ' title="' + side(b.side) + ' · ' + (b.remaining ? MG.t('seats', { n: b.remaining }) : MG.t('sold_out')) + '">' +
          '<strong>' + b.block + '</strong><small>' + side(b.side) + '</small>' +
        '</button>').join('');
      root.dispatchEvent(new CustomEvent('mg:cat-change', { bubbles: true, detail: c }));
      selectBlock(block || best(code), !block);
    }

    function selectBlock(b, auto) {
      state.block = b;
      state.auto = !!auto;
      map.select(b ? b.block : null, true);
      $$('.chip-b', root).forEach((el) => el.setAttribute('aria-checked', String(!!b && el.dataset.block === b.block)));
      update();
    }

    function update() {
      const c = cats[state.cat], b = state.block;
      if (!c) return;
      const v = b ? variantOf(b) : null;
      const already = v ? MG.cart.qtyOf(v.id) : 0;
      const room = v ? MG.cart.limit(itemOf(c, v)) : 0;
      const max = b ? Math.max(0, Math.min(b.remaining, room) - already) : 0;
      state.qty = Math.max(1, Math.min(state.qty, max || 1));
      s('qty').textContent = max > 0 ? state.qty : 0;
      $('[data-step="-1"]', root).disabled = state.qty <= 1 || max === 0;
      $('[data-step="1"]', root).disabled = state.qty >= max;
      const total = state.qty * c.price;
      const recap = b ? MG.t('block') + ' ' + b.block + ' · ' + side(b.side) + (b.bench ? ' (' + MG.t('side_of', { team: b.bench }) + ')' : '') + ' · ' + state.qty + ' ' + MG.plural(state.qty) : MG.t('choose_block');
      s('recap').textContent = recap;
      s('total').textContent = MG.money(total);
      s('bar-recap').textContent = (c.code === 'PRIME' ? 'Prime' : c.label) + ' · ' + recap;
      s('bar-total').textContent = MG.money(total);
      const can = !!b && max > 0;
      const label = can ? MG.t('add') : (b ? MG.t('limit_reached') : MG.t('choose_block'));
      [s('add'), s('bar-add')].forEach((btn) => { btn.disabled = !can; const l = $('.btn__label', btn); (l || btn).textContent = label; });
      // Places côte à côte : proposé (et coché par défaut) dès 2 billets
      s('together').hidden = !can || state.qty < 2;
      s('together-text').textContent = MG.t('together_text', { n: state.qty });
    }

    /* --- Événements --- */
    root.addEventListener('click', (e) => {
      const tile = e.target.closest('.cat-tile');
      if (tile && !tile.classList.contains('is-out')) {
        if (pageCat && tile.dataset.cat !== state.cat && goTo(tile.dataset.cat)) return;
        state.qty = 2; setCat(tile.dataset.cat); return;
      }
      const chip = e.target.closest('.chip-b');
      if (chip && !chip.disabled) { selectBlock(blocks.find((x) => x.block === chip.dataset.block), false); return; }
      const st = e.target.closest('[data-step]');
      if (st && !st.disabled) { state.qty += Number(st.dataset.step); update(); return; }
      if (e.target.closest('[data-s="add"], [data-s="bar-add"]')) add();
    });
    $('[data-stadium]', root).addEventListener('mg:block-select', (e) => {
      const b = e.detail;
      if (b.cat !== state.cat) {
        if (pageCat && goTo(b.cat, b.block)) return;
        setCat(b.cat, b);
      } else selectBlock(b, false);
    });
    document.addEventListener('mg:cart', update);

    async function add() {
      const c = cats[state.cat], b = state.block, v = b && variantOf(b);
      if (!v) return;
      [s('add'), s('bar-add')].forEach((btn) => { btn.disabled = true; });
      try {
        const added = await MG.cart.add(Object.assign(itemOf(c, v), { qty: state.qty, tier: b.tier, side: b.side, together: $('[data-together]', root).checked }));
        if (!added) MG.toast(MG.t('limit_toast'));
        else {
          if (added < state.qty) MG.toast(MG.t('partial_toast', { n: added + ' ' + MG.plural(added) }));
          MG.openCart();
        }
      } catch (err) { MG.toast(err.message || MG.t('error')); }
      update();
    }

    /* --- Barre d'achat collante --- */
    const bar = $('[data-bar]', root);
    if ('IntersectionObserver' in window) {
      let inView = false, btnVisible = true;
      const sync = () => { const on = inView && !btnVisible && !!state.block; bar.classList.toggle('is-visible', on); bar.setAttribute('aria-hidden', String(!on)); };
      new IntersectionObserver((en) => { inView = en[0].isIntersecting; sync(); }).observe(root);
      new IntersectionObserver((en) => { btnVisible = en[0].isIntersecting; sync(); }).observe(s('add'));
    }

    // État initial : catégorie de la fiche (ou de la section), sinon la première disponible hors Prime
    const params = new URLSearchParams(window.location.search);
    const pre = pageCat || root.dataset.cat;
    const fromUrl = pre && blocks.find((x) => x.block === params.get('bloc') && x.cat === pre && x.remaining);
    const firstOpen = catalog.find((c) => !byCat[c.code].out && c.code !== 'PRIME') || catalog.find((c) => !byCat[c.code].out);
    const start = cats[pre] && !byCat[pre].out ? pre : firstOpen && firstOpen.code;
    if (start) setCat(start, fromUrl || null);
  }

  let uid = 0;
  function init() {
    const catalog = readCatalog();
    if (!catalog.length || !window.MGStadium) return;
    $$('[data-selector]').forEach((root) => { uid += 1; mount(root, catalog); });
  }
  if (window.MG && window.MG.isReady) init();
  else document.addEventListener('mg:ready', init, { once: true });
})();
